import { useState, useEffect } from 'react'
import { cronLogsService } from '../services/cronLogsService'
import type { CronLog } from '../types'

export function useCronLog(id: number) {
  const [data, setData] = useState<CronLog | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const log = await cronLogsService.getById(id)
        setData(log)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error al cargar log del cron')
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [id])

  return { data, isLoading, error }
}
